import { get } from 'lodash';
import type { BackendAppConfig, RootState } from '../types';

export function getAppConfig(state: RootState): BackendAppConfig | null {
    return state.backend.config.app as BackendAppConfig | null;
}

export const getCallDetectionAppWhitelistConfig = (state: RootState) => getAppConfig(state)?.callDetection?.appWhitelist || [];

export const getSuggestionCallFrequency = (state: RootState) => getAppConfig(state)?.suggestionCallFrequency || 0;

export const getSilencDetectionThreshold = (state: RootState) =>
    get(getAppConfig(state), ['absoluteSilenceDefinition', 'consecutiveAbsoluteSilenceToEndVoicedChunkMsec']);

export const enableCallEventsPoller = (state: RootState) => get(getAppConfig(state), ['enableCallEventsPoller']);

export const shouldSendSystemSoundToAsr = (state: RootState) => get(getAppConfig(state), 'recognitionUseSystem', false);

export const enableAnonymization = (state: RootState) => get(getAppConfig(state), 'enableAnonymization', false);

export const getIsTrainerEnabled = (state: RootState) => get(getAppConfig(state), 'enableTrainer', true);

export function getPrefixOffset(state: RootState) {
    return get(getAppConfig(state), 'callDetection.prefixOffset', 0);
}

export function getExplicitIntegrationSource(state: RootState) {
    return getAppConfig(state)?.callDetection?.explicitIntegrationSource;
}

export function isRealTimeCall(state: RootState) {
    return get(getAppConfig(state), 'recordCall') !== true;
}

export function getCallMetadataOnlyFlag(state: RootState) {
    return get(getAppConfig(state), 'enableCallMetadataOnly') === true;
}

export function getCallTranscriptOnlyFlag(state: RootState) {
    return get(getAppConfig(state), 'enableCallTranscriptOnly') === true;
}

export function getEnableRecorderFlag(state: RootState) {
    return get(getAppConfig(state), 'enableRecorder') === true;
}

export function getEnableRecorderDebugFlag(state: RootState) {
    return get(getAppConfig(state), 'enableRecorderDebug') === true;
}

export function getEnableVoiceEnergyDetectionFlag(state: RootState) {
    return get(getAppConfig(state), 'enableVoiceEnergyDetection') === true;
}

export function getEnableAsrDebugFlag(state: RootState) {
    return getAppConfig(state)?.enableAsrDebug;
}

export function getDefaultCallMode(state: RootState) {
    return getAppConfig(state)?.defaultCallMode || 0;
}

export function getRecognitionForgetStreamFlag(state: RootState) {
    return get(getAppConfig(state), 'recognition.system.forgetStream');
}

export function getRealtimeOnlyCallsPercent(state: RootState) {
    return getAppConfig(state)?.realtimeOnlyCallsPercent || 0;
}
